var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderSearchLots',{attrs:{"img_header":_vm.header_image,"header":"ค้นหาล็อตสินค้า"}}),_c(_vm.currentComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }